import { Button, Flex, Hide, Show, useBreakpointValue } from '@chakra-ui/react';

import style from './Header.styled';

// import { Icon, Image, JourneyProgress, Link, Text } from '@/components';
import { Icon, Image, Link, Text } from '@/components';
import { HeaderDataType } from '@/components/layouts/SidebarLayout/SidebarLayout.type';
import DashboardJourneyProgress from '@/components/molecules/DashboardJourneyProgress';
import NotificationBanner from '@/components/molecules/NotificationBanner';
import { isValidImageUrl } from '@/helpers/utils';
import useTranslation from '@/hooks/useTranslate';

interface SideBarHeaderProps {
  isMenuOpen: boolean;
  setIsMenuOpen: any;
  data?: HeaderDataType;
  logoPath?: string;
  page?: any;
}

const DashboardHeader = ({
  isMenuOpen,
  setIsMenuOpen,
  data,
  logoPath = '/',
  page,
}: SideBarHeaderProps) => {
  const { t } = useTranslation();
  const handleToggleMenu = () => {
    setIsMenuOpen.toggle();
  };

  const aboveSmallDevice = useBreakpointValue({ base: false, md: true });
  const isDashboardPage = page === '/dashboard';

  return (
    <Flex
      __css={{
        ...style.root,
        backgroundColor: isDashboardPage ? '#ffff' : 'transparent',
        position: isDashboardPage ? 'sticky' : 'relative',
        zIndex: isDashboardPage ? 1000 : 2, //
      }}
      data-testid="about-container-id"
    >
      <Link sx={style.logo} href={logoPath}>
        {data?.logoBlack && (
          <Image
            width={data.logoBlack.fields.file.details.image.width}
            height={data.logoBlack.fields.file.details.image.height}
            src={isValidImageUrl(data?.logoBlack.fields.file.url)}
            alt={data.logoBlack.fields.title}
            lazyLoading={false}
            unoptimized
          />
        )}
      </Link>

      {/* Added progress bar in Dashboard home page */}
      {isDashboardPage && aboveSmallDevice && (
        <Flex sx={style.progressContainer}>
          {/* <JourneyProgress isHomePage={true} isDMTMobile={false} /> */}
          <DashboardJourneyProgress isHomePage />
        </Flex>
      )}

      {/* Notification Bell & Sign Out */}
      <Flex sx={style.topRightContent}>
        <NotificationBanner /> {/* Add Notification Icon & Dropdown */}
        <Hide below="lg">
          <Link sx={style.signOut} href={'/logout'}>
            <Icon name="signOut" sx={style.logoSignOut} />
            <Text as="span">{t('sign_out')}</Text>
          </Link>
        </Hide>
        <Show below="lg">
          <Button onClick={handleToggleMenu} variant={'unstyled'}>
            {isMenuOpen ? (
              <Icon name="close" sx={style.logoToggleMenu} />
            ) : (
              <Icon name="menu" sx={style.logoToggleMenu} />
            )}
          </Button>
        </Show>
      </Flex>
    </Flex>
  );
};
export default DashboardHeader;
